import * as types from '../../mutation-types';
// import statistics from './statistics';
import forms from './forms';
import dashboard from './dashboard';
import ui from './ui';
// import maps from './maps';
// import tables from './tables';
// import auth from './auth';
import extra from './extra';
import accounts from './accounts';
import park from './park';
import promotion from './promotion';
import transactions from './transactions';
import enquiries from './enquiries';
import faq from './faq';
import notifications from './notifications';
import attachments from './attachments';
import options from './options';

const state = {
  items: [
    dashboard,
    accounts,
    park,
    promotion,
    transactions,
    enquiries,
    faq,
    notifications,
    attachments,
    options,
    // statistics,
    forms,
    // tables,
    ui,
    extra,
    // auth,
    // maps,
  ],
};

const mutations = {
  [types.TOGGLE_EXPAND_MENU_ITEM] (state, payload) {
    let menuItem = payload.menuItem;
    let expand = payload.expand;
    if (menuItem.children && menuItem.meta) {
      menuItem.meta.expanded = expand;
    }
  },
};

const actions = {
  toggleExpandMenuItem ({ commit }, payload) {
    commit(types.TOGGLE_EXPAND_MENU_ITEM, payload);
  },
};

export default {
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/index.js